/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonIdUser200,
  GetApiV1PersonIdUser401,
  GetApiV1PersonIdUser404,
  GetApiV1PersonIdUser500,
  GetApiV1PersonIdUserPathParams,
  GetApiV1PersonIdUserQueryResponse,
} from "../../types/personUserController/GetApiV1PersonIdUser.ts";
import { personUserDataViewModelSchema } from "../personUserDataViewModelSchema.ts";

export const getApiV1PersonIdUserPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1PersonIdUserPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonIdUser200Schema = z.lazy(
  () => personUserDataViewModelSchema,
) as unknown as ToZod<GetApiV1PersonIdUser200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonIdUser401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdUser401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1PersonIdUser404Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdUser404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonIdUser500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdUser500>;

export const getApiV1PersonIdUserQueryResponseSchema = z.lazy(
  () => getApiV1PersonIdUser200Schema,
) as unknown as ToZod<GetApiV1PersonIdUserQueryResponse>;
